export default __webpack_public_path__ + "static/media/hausa.ff3a5d12.svg";